import { ReactElement } from "react";
import { useDataInputDialog } from "client/Hooks";
import { Dialog, Toolbar } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export type UnsavedChangesDialogProps = {
	onClose(): void;
	onConfirm(shouldSave: boolean): void;
};

export const UnsavedChangesDialog = (
	props: UnsavedChangesDialogProps
): ReactElement => {
	const {
		onConfirm,
		onClose
	} = props;

	return (
		<Dialog trackingId="integration-builder-unsaved-changes-dialog">
			<Dialog.Header
				title={localize("_AreYouSureYouWantToLeaveThisPage")}
			/>
			<Dialog.Body>
				<p>
					{localize("_YouHaveUnsavedChanges")}
				</p>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_Save")}
						onClick={() => onConfirm(true)}
						trackingId="save"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_DiscardChanges")}
						onClick={() => onConfirm(false)}
						trackingId="discard-changes"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
						trackingId="cancel"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
UnsavedChangesDialog.displayName = "UnsavedChangesDialog";

export type UnsavedChangesDialogInitialData = Omit<
	UnsavedChangesDialogProps,
	"onClose" | "onConfirm"
>;
export function useUnsavedChangesDialog(): [
	element: ReactElement | null,
	open: (props: UnsavedChangesDialogInitialData) => Promise<TryResult<boolean>>
] {
	return useDataInputDialog(
		(props, onClose, onConfirm) => (
			<UnsavedChangesDialog
				{...props}
				onClose={onClose}
				onConfirm={onConfirm}
			/>
		)
	);
}
